import {useCallback, useState} from "react";
import {platformFormAPI} from "../../../api/axiosConfig";

export function useUploadSirenAudio() {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState<string | null>(null);

    const upload = useCallback(async (file: File, name: string): Promise<string | null> => {
        setUploading(true);
        setProgress(0);
        setError(null);
        try {
            const form = new FormData();
            form.append("file", file);
            form.append("name", name);
            const res = await platformFormAPI.post<{id: string}>("api/siren/audio-files/upload", form, {
                onUploadProgress: (e) => {
                    if (e.total) setProgress(Math.round((e.loaded / e.total) * 100));
                },
            });
            setProgress(100);
            return res.data.id;
        } catch (e: any) {
            const fieldError = e?.response?.data?.errors?.file?.[0];
            setError(fieldError ?? "error uploading audio file");
            return null;
        } finally {
            setUploading(false);
        }
    }, []);

    return {upload, uploading, progress, error};
}
